import { render, staticRenderFns } from "./LoginSSO2.vue?vue&type=template&id=3446da1e&scoped=true&"
import script from "./LoginSSO2.vue?vue&type=script&lang=js&"
export * from "./LoginSSO2.vue?vue&type=script&lang=js&"
import style0 from "./LoginSSO2.vue?vue&type=style&index=0&id=3446da1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3446da1e",
  null
  
)

export default component.exports